import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-tendance-marche-immobilier-read-mode',
  templateUrl: './tendance-marche-immobilier-read-mode.component.html',
  styleUrls: ['./tendance-marche-immobilier-read-mode.component.scss'],
})
export class TendanceMarcheImmobilierReadModeComponent {
  @Input() tendencies!: Report.Tendencies;
  @Input() reportId!: string;
}
